import { put } from 'redux-saga/effects';
import { getUserSubscriptionsSuccess, getUserSubscriptionsFailure } from 'redux/actions';
import { getUserSubscriptionsApiRequest } from 'api/balloon';

export function* getUserSubscriptionsSaga() {
  try {
    const { data: response } = yield getUserSubscriptionsApiRequest();

    if (response.errors) {
      yield put(getUserSubscriptionsFailure(response.errors));
      return;
    }
    const now = new Date();

    const subscriptions = (response.data.me?.subscriptions || []).filter((subscription) => {
      const _validTil = subscription.validTil || new Date();
      subscription.validTil = new Date(_validTil);
      return subscription.validTil >= now;
    });

    yield put(getUserSubscriptionsSuccess({ subscriptions }));
  } catch (error) {
    yield put(getUserSubscriptionsFailure(error));
  }
}
